import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

class Schedule extends Component {
  constructor (props) {
    super(props)

    this.state = {
      schedule: {},
      extended: {}
    }

    this.showContent = this.showContent.bind(this)
    this.isHappeningNow = this.isHappeningNow.bind(this)
  }

  componentDidMount () {
    const { schedules } = this.props

    this.setState({ schedule: schedules[this.props.location] })
  }

  showContent (time) {
    let newExtended = { ...this.state.extended }
    newExtended[time] = !newExtended[time]
    this.setState({ extended: newExtended })
  }

  isHappeningNow (time) {
    const times = Object.keys(this.state.schedule)
    const index = times.indexOf(time)

    if (!times[index + 1]) {
      return false
    }

    if (moment(new Date(time)) < moment() && moment() < moment(new Date(times[index + 1]))) {
      return true
    }
  }

  render () {
    const { schedule } = this.state
    const times = Object.keys(schedule)
    const start = times[0]
    const end = times.slice(0).pop()
    const timesDayOne = times.filter(t => t.split(' ')[1] === start.split(' ')[1])
    const timesDayTwo = times.filter(t => t.split(' ')[1] === end.split(' ')[1])

    return (
      <div className='main-col-cell'>
        <div className='dashboard-shedule'>
          <div className='headline'><h4 className='darkestgrey'>SCHEDULE</h4></div>
          <div className='y-scroll-wrap'>
            <div className='y-scroll'>
              <div className='dashboard-shedule-list'>
                <div className='dashboard-shedule-row'>
                  <div className={`shedule-day ${moment(new Date(start)).weekday() === moment().weekday() ? 'darkestgrey' : ''}`}>
                    <h4>{moment(new Date(start)).format('dddd')},<br />{moment(new Date(start)).format('MMMM Do')}</h4>
                  </div>
                  <div className='shedule-list'>
                    {timesDayOne.map((time, index) => (
                      <div
                        key={index}
                        className={`${this.state.extended[time] ? 'show-content' : ''} ${this.isHappeningNow(time) ? 'happening-now' : ''}`}>
                        <div className='headbox'>
                          <div className='hour-cell'>{moment(new Date(time)).format('HH:mm')}</div>
                          <div className='title-cell'><h5>{schedule[time].title}</h5></div>
                          <div className='ico-cell' onClick={() => this.showContent(time)}><div className='ico' /></div>
                        </div>
                        <div className='content'>
                          {schedule[time].description}
                        </div>
                        {this.isHappeningNow(time) && <div className='happening-now-box'>happening now</div>}
                      </div>
                    ))}
                  </div>
                </div>
                <div className='dashboard-shedule-list'>
                  <div className='dashboard-shedule-row'>
                    <div className='shedule-day'>
                      <h4>{moment(new Date(end)).format('dddd')},<br />{moment(new Date(end)).format('MMMM Do')}</h4>
                    </div>
                    <div className='shedule-list'>
                      {timesDayTwo.map((time, index) => (
                        <div
                          key={index}
                          className={`${this.state.extended[time] ? 'show-content' : ''} ${this.isHappeningNow(time) ? 'happening-now' : ''}`}>
                          <div className='headbox'>
                            <div className='hour-cell'>{moment(new Date(time)).format('HH:mm')}</div>
                            <div className='title-cell'><h5>{schedule[time].title}</h5></div>
                            <div className='ico-cell' onClick={() => this.showContent(time)}><div className='ico' /></div>
                          </div>
                          <div className='content'>
                            {schedule[time].description}
                          </div>
                          {this.isHappeningNow(time) && <div className='happening-now-box'>happening now</div>}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.auth.user.location,
    schedules: state.general.schedules
  }
}

export default connect(mapStateToProps)(Schedule)



// WEBPACK FOOTER //
// ./src/screens/dashboard/Schedule.js